module.exports = __webpack_public_path__ + "img/16.70e4fe09.png";